import React, { FunctionComponent } from 'react'
import classnames from 'classnames'

import GrowingTextarea from './growingTextarea'

interface Meta {
  submitFailed: boolean
  error: string
}

export interface Props {
  label: string
  input: any // TODO-TS
  className: string
  meta: Meta
}

const TextareaField: FunctionComponent<Props> = ({
  label,
  input,
  meta,
  className,
  ...rest
}) => {
  return (
    <div className="form__group">
      <label htmlFor={input.name} className="form__label">
        {label}
      </label>
      <GrowingTextarea
        className={classnames('form__control form__textarea', className, {
          'form__control--error': meta.submitFailed && meta.error,
        })}
        name={input.name}
        id={input.name}
        minHeight={190}
        {...input}
        {...rest}
      />
      {meta.submitFailed && meta.error && (
        <p className="form__help-text text-error" data-test="error-message">
          <b>{meta.error}</b>
        </p>
      )}
    </div>
  )
}

TextareaField.displayName = 'TextareaField'

export default TextareaField
